var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M527.003 0.238l-131.215-0.238c-147.647 0-243.14 98.828-243.14 251.952v116.212h-131.929c-11.451 0.040-20.719 9.333-20.719 20.789 0 0.059 0 0.117 0.001 0.176v-0.009 168.365c0.014 11.437 9.281 20.705 20.717 20.718h131.931v424.841c0 0.050-0.001 0.108-0.001 0.167 0 11.457 9.268 20.749 20.715 20.789h172.417c11.451-0.040 20.719-9.333 20.719-20.789 0-0.059 0-0.117-0.001-0.176v0.009-424.841h154.314c11.437-0.014 20.705-9.281 20.718-20.717v-168.366c0-0.022 0-0.049 0-0.075 0-5.713-2.271-10.896-5.959-14.695l0.005 0.005c-3.761-3.819-8.986-6.187-14.764-6.192h-154.315v-98.352c0-47.39 10.954-71.442 72.156-71.442h88.35c11.468-0.121 20.718-9.446 20.718-20.931 0-0.009 0-0.018 0-0.026v0.001-156.22c0-0.050 0.001-0.108 0.001-0.167 0-11.457-9.268-20.749-20.715-20.789h-0.004z"}));
}

FacebookIcon.defaultProps = {"viewBox":"0 0 548 1024"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
